import { useViewport } from '@chilecompra/react-kit'
import { Breadcrumb, Breadcrumbs, Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'
import React from 'react'

import { Navigation, Root } from './HeadingSection.styles'

/**
 * Renders a string wrapped in a Typography with the given props, or a custom node as-is.
 */
const renderText = (content, typographyProps) =>
  typeof content === 'string' ? <Typography {...typographyProps}>{content}</Typography> : content

/**
 * The HeadingSection container.
 */
const HeadingSection = ({ breadcrumbs, subtitle, title }) => {
  const { size } = useViewport()

  return (
    <Root className="heading-section">
      {size.isUpToMedium && (
        <Navigation className="navigation">
          <Breadcrumbs className="breadcrumbs">
            {breadcrumbs.map((breadcrumb, index) =>
              breadcrumb.link ? (
                <Breadcrumb
                  className="breadcrumb-link"
                  key={`breadcrumb-link-${index}`}
                  to={breadcrumb.link}
                  variant="link"
                  {...(breadcrumb.isExternal && {
                    onClick: breadcrumb.onClick || undefined,
                    target: '_top',
                    type: 'external'
                  })}
                >
                  {breadcrumb.text}
                </Breadcrumb>
              ) : (
                <Breadcrumb className="breadcrumb-text" key={`breadcrumb-text-${index}`} variant="text">
                  {breadcrumb.text}
                </Breadcrumb>
              )
            )}
          </Breadcrumbs>
        </Navigation>
      )}

      {renderText(title, { fontWeight: 'bold', margin: '2.3rem 0 0.2rem', variant: 'h2' })}

      {subtitle && renderText(subtitle, { variant: 'body2' })}
    </Root>
  )
}

HeadingSection.defaultProps = {
  breadcrumbs: [],
  title: ''
}

HeadingSection.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      isExternal: PropTypes.bool,
      link: PropTypes.string,
      text: PropTypes.string.isRequired
    })
  ).isRequired,
  subtitle: PropTypes.node,
  title: PropTypes.node.isRequired
}

export default HeadingSection
